var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1163_9421)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 144,
    height: 144,
    rx: 36,
    fill: "#E9F3EA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 143,
    height: 143,
    rx: 35.5,
    stroke: "#84CC87"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1163_9421)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 124,
    height: 124,
    rx: 36,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1163_9421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5 98.5H83.5",
    stroke: "#73C947",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 89.125V98.5",
    stroke: "#73C947",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5938 76H57.25C55.2609 76 53.3532 75.2098 51.9467 73.8033C50.5402 72.3968 49.75 70.4891 49.75 68.5V64.75C49.75 64.2527 49.9475 63.7758 50.2992 63.4242C50.6508 63.0725 51.1277 62.875 51.625 62.875H59.125",
    stroke: "#73C947",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4062 76H94.75C96.7391 76 98.6468 75.2098 100.053 73.8033C101.46 72.3968 102.25 70.4891 102.25 68.5V64.75C102.25 64.2527 102.052 63.7758 101.701 63.4242C101.349 63.0725 100.872 62.875 100.375 62.875H92.875",
    stroke: "#73C947",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 57.25H91C91.4973 57.25 91.9742 57.4475 92.3258 57.7992C92.6775 58.1508 92.875 58.6277 92.875 59.125V72.0391C92.875 81.3437 85.4336 89.0547 76.1289 89.125C73.902 89.142 71.6938 88.7181 69.6315 87.8777C67.5693 87.0372 65.6937 85.7969 64.1131 84.2282C62.5324 82.6595 61.2778 80.7935 60.4218 78.7377C59.5657 76.6819 59.1249 74.4769 59.125 72.25V59.125C59.125 58.6277 59.3225 58.1508 59.6742 57.7992C60.0258 57.4475 60.5027 57.25 61 57.25Z",
    stroke: "#73C947",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1163_9421",
    x: -8,
    y: -8,
    width: 168,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1163_9421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1163_9421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1163_9421",
    x: 0,
    y: 0,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1163_9421"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1163_9421",
    result: "effect2_dropShadow_1163_9421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1163_9421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1163_9421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(46 46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWin);
export default __webpack_public_path__ + "static/media/win.35228443afc503938ca7638ab46e327a.svg";
export { ForwardRef as ReactComponent };